/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Sample_Viewerfallback1Inputs */

const ja_playdata_sample_viewerfallback1 = /** @type {(inputs: Playdata_Sample_Viewerfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザではレポートを埋め込み表示できません。上のボタンからダウンロードしてご覧ください。`)
};

const en_playdata_sample_viewerfallback1 = /** @type {(inputs: Playdata_Sample_Viewerfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser cannot display the report inline. Use the download button above to open it.`)
};

/**
* | output |
* | --- |
* | "This browser cannot display the report inline. Use the download button above to open it." |
*
* @param {Playdata_Sample_Viewerfallback1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_sample_viewerfallback1 = /** @type {((inputs?: Playdata_Sample_Viewerfallback1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Sample_Viewerfallback1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_sample_viewerfallback1(inputs)
	return en_playdata_sample_viewerfallback1(inputs)
});
export { playdata_sample_viewerfallback1 as "playdata_sample_viewerFallback" }